<template>
  <main id="index">
    <h1>Industrie ACL</h1>
    <article id="slider">
      <flickity :options="flickityOptions">
        <div class="carousel-cell">
          <img src="@/assets/images/slides/pliage_metal_acl.jpg" alt="Pliage de métal">
        </div>
        <div class="carousel-cell">
          <img src="@/assets/images/slides/pliage_metal_acl_2.jpg" alt="Pliage de métal">
        </div>
        <div class="carousel-cell">
          <img src="@/assets/images/slides/soudure_metal_acl.jpg" alt="Soudure sur métal">
        </div>
      </flickity>
    </article>
    <article id="pro">
      <div class="colum">
        <h2>Professionnalisme, renommée et crédibilité.</h2>
        <p>
          Chez Industrie ACL, nous concevons, fabriquons et
          transformons toute structure de métalé Depuis notre
          arrivée sur le marché en 2001, notre service à la
          clientèle exceptionnel et le professionnalisme de
          toute notre équipe ont fait notre renommée et notre
          crédibilité.
        </p>
        <router-link :to="{ name: 'AboutUs' }" class="FullBtn">lire la suite</router-link>
      </div>
      <aside>
        <img src="@/assets/images/index/index_01.jpg" alt="">
      </aside>
    </article>
    <div class="gray-bg">
      <article id="service">
        <aside>
          <img src="@/assets/images/index/index_02.jpg" alt="">
        </aside>
        <div class="colum">
          <h2>Une gamme de services complète</h2>
          <ul>
            <li>Pliage</li>
            <li>Soudure spécialisée</li>
            <li>Cintrage tubulaire</li>
            <li>Conception</li>
            <li>Usinage conventionnel</li>
          </ul>
          <router-link :to="{ name: 'Services.Cintrage' }" class="FullBtn">Voir les services</router-link>
        </div>
      </article>
    </div>
  </main>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  components: {
    Flickity
  },
  data () {
    return {
      flickityOptions: {
        autoPlay: 5000,
        wrapAround: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue